/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
export enum HostAccessMode {
    Balance = '0',
    Asymmetric = '1'
}

export enum MappingTypeOfHostE {
    HOST = 'host',
    HostGroup = 'hostGroup'
}

export enum HostNoRedundancyCheckE {
    DISABLE = '0',
    ENABLE = '1',
}
